// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  font-size: var(--font-size-xl);
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-xxl);
  font-weight: bold;
}

.icon-display-numbered {
  min-width: var(--input-element-height);
  min-height: var(--input-element-height);
  font-size: var(--font-size-m);
}

.icon-display-large-numbered {
  min-width: var(--input-element-height-large);
  min-height: var(--input-element-height-large);
  font-size: var(--font-size-l);
}

.icon-display-numbered,
.icon-display-large-numbered {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  align-items: center;
  justify-content: center;
  padding: 0 var(--input-element-gap);
}

.icon-display-vertical {
  flex-direction: column;
  padding: unset;
}
`, "",{"version":3,"sources":["webpack://./src/ui/style/elements/display-elements.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;EAC5C,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":["header {\n  font-size: var(--font-size-xl);\n  font-weight: bold;\n}\n\nh1 {\n  font-size: var(--font-size-xxl);\n  font-weight: bold;\n}\n\n.icon-display-numbered {\n  min-width: var(--input-element-height);\n  min-height: var(--input-element-height);\n  font-size: var(--font-size-m);\n}\n\n.icon-display-large-numbered {\n  min-width: var(--input-element-height-large);\n  min-height: var(--input-element-height-large);\n  font-size: var(--font-size-l);\n}\n\n.icon-display-numbered,\n.icon-display-large-numbered {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  align-items: center;\n  justify-content: center;\n  padding: 0 var(--input-element-gap);\n}\n\n.icon-display-vertical {\n  flex-direction: column;\n  padding: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
